import { HOME_SECTION_IDS } from '@/shared/constants/homeSectionIds';

export { HOME_SECTION_IDS };

export const HOME_SECTION_LABELS = {
  [HOME_SECTION_IDS.OBJAVE]: 'Објаве',
  [HOME_SECTION_IDS.POU]: 'Шта је ПОУ',
  [HOME_SECTION_IDS.IMPLEMENTATION]: 'Спровођење',
  [HOME_SECTION_IDS.PLANNING]: 'Планирање',
  [HOME_SECTION_IDS.ARCHIVE]: 'Архива',
};

/** Offset ispod sticky header-a (mid-bar ~55px + razmak). */
export const HOME_SECTION_SCROLL_OFFSET = 72;
